import {
  IGeneralEligibilityRequirement,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { RequirementTableItemData } from "../../types";

export enum CustomRequirementType {
  TaxForm = "TaxForm",
  InfoShare = "InfoShare"
}

export type ExtendedGeneralRequirement =
  | IGeneralEligibilityRequirement
  | CustomGeneralRequirementItem;

export type ExtendedRequirementItem =
  | RequirementTableItemData
  | IGeneralEligibilityRequirement
  | CustomGeneralRequirementItem;

export interface CustomGeneralRequirementItem {
  requirementType: CustomRequirementType;
  status: RequirementStatus;
  completedPayersLength?: number;
  allPayersLength?: number;
  payerId?: string;
}
